import React, { useEffect, useState } from 'react';
import TariffsAutomotorSwiper from './TariffsAutomotorSwiper';
import Spinner from 'components/spinner/Spinner';
// import { forEach } from 'lodash';

type Props = { tariffs };

type Tariff = {
  codfou: string
  has_price: boolean
  logo: string
  supplier_logo: string
  supplier_name: string; 
  type: string
  updated_at: string
};

const TariffsAutomotor: React.FC<Props> = (props) => {

  const [suppliersWithPrice, setSuppliersWithPrice] = useState<Tariff[]>([]);

  useEffect(() => {
    if (props.tariffs) {
      const newArrayTarifsFilterd = Object.values(props.tariffs)
        .flatMap((arr) => arr as Tariff[])
        .filter((item) => item.has_price === true);
 
      setSuppliersWithPrice(newArrayTarifsFilterd);
    }
  }, [props.tariffs]);


  return <div className="tariffs">
   
    {props.tariffs !== null && typeof props.tariffs !== 'string' && Object.keys(props.tariffs).length ?

      
      Object.keys(props.tariffs).map((item) => {

        return <TariffsAutomotorSwiper data={props.tariffs[item]} key={item} title={item} length={props.tariffs[item].length} suppliersWithPrice={suppliersWithPrice}/>;

      })
      :
      <Spinner class="small" />
    }
  </div>;
};


export default TariffsAutomotor;


